import { BoardScene } from './../BoardScene';
import { GameVars } from './../../../GameVars';
import { BoardManager } from "../BoardManager";
import { AudioManager } from '../../../AudioManager';

export class Card extends Phaser.GameObjects.Image {

    public cardValue: CardValue;

    constructor(scene: Phaser.Scene, x: number, y: number, cardValue: CardValue) {
       
        super(scene, x, y, "texture_atlas_2", "back_deck_" + GameVars.gameData.backStyle);

        this.cardValue = cardValue;

        this.setAngle(Math.random() * 4 - 2);

        this.setInteractive();
        this.input.enabled = false;

        this.on("pointerdown", this.onCardDown, this);
    }

    public flip(): void {

        if (!this.frame.name.includes("back_deck")) {
            return;
        }

        AudioManager.playSound("card_reveal_" + Math.ceil(Math.random() * 3));

        this.scene.tweens.add({
            targets: this,
            scaleX: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 150,
            onComplete: () => {

                let textureName: string =  this.cardValue.suit.toString() + "_" + this.cardValue.value;
                this.setFrame(textureName);

                this.scene.tweens.add({
                    targets: this,
                    scaleX: 1,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    duration: 250
                });
            },
            onCompleteScope: this
        });
    }

    public unflip(): void {

        if (this.frame.name.includes("back_deck")) {
            return;
        }

        AudioManager.playSound("card_reveal_" + Math.ceil(Math.random() * 3));

        this.scene.tweens.add({
            targets: this,
            scaleX: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 150,
            onComplete: () => {

                this.setFrame("back_deck_" + GameVars.gameData.backStyle);

                this.scene.tweens.add({
                    targets: this,
                    scaleX: 1,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    duration: 250
                });
            },
            onCompleteScope: this
        });
    }

    public setValue(cardValue: CardValue): void {

        this.cardValue = cardValue;

        let textureName: string = cardValue.suit.toString() + "_" + cardValue.value;
        this.setFrame(textureName);
    }

    public changeBack(): void {

        if (this.frame.name.includes("back_deck")) {
            this.setFrame("back_deck_" + GameVars.gameData.backStyle);
        }
    }

    public enableInput(): void {

        this.input.enabled = true;
    }

    public disableInput(): void {
        this.input.enabled = false;
    }

    private onCardDown(): void {

        BoardManager.playerCardToWastePile(this.cardValue);

        if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 7) {
            BoardScene.currentInstance.removeTutorial();
            GameVars.tutorialCount = 8;
        }
    }
}
